import React, { useEffect, useState } from "react";
import './TransferirServicios.scss'
import '../../../components/molecules/TablaBitacoras/TablaBitacoras.scss'
import TitleView from "../../../components/atoms/TitleView/TitleView";
import GlovalCard from "../../../components/atoms/GlovalCard/GlovalCard";
import InputCalendario from "../../../components/atoms/InputCalendario/InputCalendario";
import InputLista from "../../../components/atoms/InputLista/InputLista";
import TextArea from "../../../components/atoms/TextArea/TextArea";
import Button from "../../../components/atoms/Button/Button";
import { getClients } from "../MonitoreoServicios/MonitoreoServiciosIntegracion";
import { transferisServiciosIntegracion } from "./transferisServiciosIntegracion";
import { formateoBasico, isoAUtc } from "../../../utilities/formateos";
import Swal from "sweetalert2";
import { Card } from 'primereact/card';
import { jwtDecode } from "jwt-decode";
import { getCausa, getEfectos, getIncidente, resistrarIncidente, updateIncidente } from "../../../components/molecules/TablaBitacoras/TablaBitacorasntegracion";
import ButtonGris from "../../../components/atoms/ButtonGris/ButtonGris";
import { logDOM } from "@testing-library/react";
import { Tooltip } from "@mui/material";
const keytoken = process.env.REACT_APP_CLAVE_INCRIPTACION;
const TransferirServicios = () => {
    // inputs
    const [clientes, setClientes] = useState([])
    const [cliente, setCliente] = useState("")
    const [rutas, setRutas] = useState([])
    const [ruta, setRuta] = useState("")
    const [estructuras, setEStructuras] = useState([])
    const [estructura, setEStructura] = useState(null)
    const [lunes, setLunes] = useState(0)
    const [martes, setMartes] = useState(0)
    const [miercoles, setMiercoles] = useState(0)
    const [jueves, setJueves] = useState(0)
    const [viernes, setViernes] = useState(0)
    const [sabado, setSabado] = useState(0)
    const [domingo, setDomingo] = useState(0)
    const [desde, setDesde] = useState(formateoBasico(new Date()))
    const [hasta, setHasta] = useState(formateoBasico(new Date()))
    const [proveedores, setProveedores] = useState([{ name: "SUMA TE LLEVA", code: 1 }])
    const [proveedor, setProveedor] = useState([])
    const [operadores, setOperadores] = useState([])
    const [operador, setOperador] = useState(null)
    const [motivo, setMotivo] = useState(null)
    const [transeferir, setTransferir] = useState(null)
    // ------------------------------------------------------------------------------- inicio INCIDENTES
    const [fecha, setFecha] = useState(formateoBasico(new Date()))
    const [causas, setCausas] = useState([])
    const [causa, setCausa] = useState(null)
    const [efectos, setEfectos] = useState([])
    const [efecto, setEfecto] = useState(null)
    const [afectoServicioCheck, setAfectoServicioCheck] = useState(false)
    const [responsabilidadSumaCheck, setResponsabilidadSumaCheck] = useState(true)
    const [facturaCheck, setFacturaCheck] = useState(false)
    const [detalle, setDetalle] = useState(null)
    const [notaFacturacion, setNotaFacturacion] = useState(null)
    const [incidenteData, setIncidenteData] = useState(null)
    const [tipoReembolso, setTipoReembolso] = useState("taxi")
    const [data, setData] = useState(null)
    const [registrarIncidencia, setRegistrarIncidencia] = useState(true)

    useEffect(() => {
        if (data) {
            getCausa(setCausas, 'tranferir')
            // getIncidente(setIncidenteData, data?.bitacora)
        }
    }, [data])
    useEffect(() => {
        if (causa) {
            getEfectos(setEfectos, causa.code)
            // getIncidente(setIncidenteData, data?.bitacora)
        }
    }, [causa])
    useEffect(() => {
        setEStructura(null)
    }, [desde,hasta,cliente,ruta])


    // ------------------------------------------------------------------------------- FIN INCIDENTES

    useEffect(() => {
        getClients(setClientes)
        transferisServiciosIntegracion.getProveedores(setProveedores)
        setProveedor({ name: "SUMA TE LLEVA", code: 1 })
        transferisServiciosIntegracion.getOperadores(setOperadores)
    }, [])
    useEffect(() => {
        if (cliente) {
            transferisServiciosIntegracion.getRutesByIdClient(cliente.code, setRutas)
        }

    }, [cliente])
    useEffect(() => {
        if (ruta) {

            transferisServiciosIntegracion.getEstructuraByRuta(ruta.code, setEStructuras)
        }

    }, [ruta])
    useEffect(() => {
        if (estructura) {



            setLunes(estructura.LUNES)
            setMartes(estructura.MARTES)
            setMiercoles(estructura.MIERCOLES)
            setJueves(estructura.JUEVES)
            setViernes(estructura.VIERNES)
            setSabado(estructura.SABADO)
            setDomingo(estructura.DOMINGO)
            transferisServiciosIntegracion.getBitacora(desde, hasta, estructura.code, setData, setRegistrarIncidencia)
        }

    }, [estructura])
    useEffect(() => {
        setOperador(null)
    }, [proveedor])

   

    const send = () => {
        if (cliente?.code && estructura?.code && ruta?.code && motivo) {
            
            
            if (proveedor?.code == 1) {
               
                if (registrarIncidencia == 1) {

                     const dataInt = {
                    fecha_inicio: "'" + desde + " 00:00:00'",
                    fecha_fin: "'" + hasta + " 23:59:59'",
                    cliente: cliente?.code,
                    estructura: estructura?.code,
                    proveedor: proveedor?.code,
                    operador: operador?.code,
                    ruta: ruta?.code,
                    motivo: motivo,
                    transferidoPor: "Transferido por :" + jwtDecode(sessionStorage.getItem("token")).NOMBRE,
                    transferidoPorId: jwtDecode(sessionStorage.getItem("token")).ID,
                    esRescate:true
                }
                    if (causa && efecto && detalle) {
                        transferisServiciosIntegracion.transferirOperador(dataInt, setTransferir)
                    }
                }
                else {
                     const dataInt = {
                    fecha_inicio: "'" + desde + " 00:00:00'",
                    fecha_fin: "'" + hasta + " 23:59:59'",
                    cliente: cliente?.code,
                    estructura: estructura?.code,
                    proveedor: proveedor?.code,
                    operador: operador?.code,
                    ruta: ruta?.code,
                    motivo: motivo,
                    transferidoPor: "Transferido por :" + jwtDecode(sessionStorage.getItem("token")).NOMBRE,
                    transferidoPorId: jwtDecode(sessionStorage.getItem("token")).ID,
                    esRescate:false
                }
                    transferisServiciosIntegracion.transferirOperador(dataInt, setTransferir)
                }
            }
            else {
                if (proveedor?.code != 1) {
                    
                    if (registrarIncidencia == 1) {
                        const data = {
                        fecha_inicio: "'" + desde + " 00:00:00'",
                        fecha_fin: "'" + hasta + " 23:59:59'",
                        cliente: cliente?.code,
                        estructura: estructura?.code,
                        proveedor: proveedor?.code,
                        operador: operador?.code,
                        ruta: ruta?.code,
                        motivo: motivo,
                        transferidoPor: "Transferido por :" + jwtDecode(sessionStorage.getItem("token")).NOMBRE,
                        transferidoPorId: jwtDecode(sessionStorage.getItem("token")).ID,
                        esRescate:true
                    }
                    console.log("causa",causa?.code);
                    console.log("efecto",efecto);
                    console.log("notaFacturacion",notaFacturacion);
                    console.log("detalle",detalle);
                        if (causa && efecto && detalle) {
                            transferisServiciosIntegracion.transferirOperador(data, setTransferir)
                        }
                    }
                    else {
                        const data = {
                        fecha_inicio: "'" + desde + " 00:00:00'",
                        fecha_fin: "'" + hasta + " 23:59:59'",
                        cliente: cliente?.code,
                        estructura: estructura?.code,
                        proveedor: proveedor?.code,
                        operador: operador?.code,
                        ruta: ruta?.code,
                        motivo: motivo,
                        transferidoPor: "Transferido por :" + jwtDecode(sessionStorage.getItem("token")).NOMBRE,
                        transferidoPorId: jwtDecode(sessionStorage.getItem("token")).ID,
                        esRescate:false
                    }
                        transferisServiciosIntegracion.transferirOperador(data, setTransferir)
                    }
                }
                else {

                    Swal.fire({
                        icon: 'error',   // Icono de error
                        text: 'Rellena todos los campos obligatorios', // Mensaje de error
                        confirmButtonText: 'OK'  // Texto del botón de confirmación
                    });
                }
            }

        }
        else {
            Swal.fire({
                icon: 'error',   // Icono de error
                text: 'Rellena todos los campos obligatorios', // Mensaje de error
                confirmButtonText: 'OK'  // Texto del botón de confirmación
            });
        }
    }
 
    useEffect(() => {
        if (transeferir) {
            console.log(transeferir);
            
            if (typeof (transeferir.data) == 'string' || transeferir.message) {
                Swal.fire({
                    icon: 'error',   // Icono de error
                    title: 'Oops...', // Título de la alerta
                    text: transeferir.data ? transeferir.data : transeferir.message, // Mensaje de error
                    confirmButtonText: 'OK'  // Texto del botón de confirmación
                });
            }
            else {
                if (registrarIncidencia == 1) {


                    if (causa && efecto && detalle) {
                        const token = sessionStorage.getItem("token")
                        const dataUser = jwtDecode(token, keytoken)
                        data.map(async (item) => {
                         
                            if(item.mostrar_incidencia == 1)
                            {
                                const dataRegistrarIncidente = {
                                    id_causa: causa.code,
                                    detalle: detalle,
                                    id_efecto: efecto.code,
                                    facturar: facturaCheck === true ? '1' : facturaCheck === false ? '0' : null,
                                    fecha: isoAUtc(item.fecha) + " " + "00:00:00",
                                    id_unidad: item.id_unidad,
                                    nota_facturacion: notaFacturacion,
                                    responsabilidad_suma: causa.RESPONSABILIDAD_SUMA === true ? '1' : causa.RESPONSABILIDAD_SUMA === false ? '0' : null,
                                    id_usuario: dataUser.ID,//usuario quien hace la transferencia 
                                    tipo: causa.TIPO,
                                    afecto_servicio: causa.AFECTA_SERVICIO === true ? '1' : causa.AFECTA_SERVICIO === false ? '0' : null,//usuario quien hace la transferencia 
                                    id_bitacora: item.bitacora,
                                    id_chofer: item.id_chofer,
                                    // tipoReembolso: tipoReembolso,
                                    usuario_incidente: "Incidencia hecha por :" + jwtDecode(sessionStorage.getItem("token")).NOMBRE,
                                    
                                }
                                Swal.fire({
                                    title: 'Cargando...',
                                    text: 'Obteniendo datos...',
                                    allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
                                    allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
                                    didOpen: () => {
                                        Swal.showLoading();     // Muestra el spinner de carga
                                    }
                                })
                                await resistrarIncidente(dataRegistrarIncidente, limpiarDatos)
                                transferisServiciosIntegracion.getBitacora(desde, hasta, estructura.code, setData)
                            }
                        })

                    }
                    else {
                        Swal.fire({
                            icon: 'error',   // Icono de error
                            title: 'Oops...', // Título de la alerta
                            text: 'rellena todos los campos de la incidencia obligatorios', // Mensaje de error
                            confirmButtonText: 'OK'  // Texto del botón de confirmación
                        });
                    }

                }

            }
        }
    }, [transeferir])
    // desactivar los checks que no coincidem
    const limpiarDatos = () => {
        setCausa(null)
        setEfecto(null)
        setDetalle(null)
        setNotaFacturacion(null)
    }
    
    return (
        <div className="TransferirServicios">
            <TitleView title={"Transferir servicios"}></TitleView>
            <GlovalCard>
                <b>
                    <div className="contenedorPrincipal">
                        <div className="contenedorInputs">
                            <InputCalendario value={desde} onChange={(e) => { setDesde(e.target.value) }} titulo={"Desde"}></InputCalendario>
                            <InputCalendario value={hasta} onChange={(e) => { setHasta(e.target.value) }} titulo={"Hasta"}></InputCalendario>
                            <InputLista options={clientes} value={cliente} onChange={(e) => { setCliente(e.value) }} titulo={"Cliente"}></InputLista>
                        </div>
                        <div className="contenedorInputs">
                            <InputLista options={rutas} value={ruta} onChange={(e) => { setRuta(e.value) }} titulo={"Ruta"}></InputLista>
                            <InputLista options={estructuras} value={estructura} onChange={(e) => { setEStructura(e.value) }} titulo={"Estructura"}></InputLista>
                        </div>
                        <div className="contenedorInputs">
                            <InputLista options={proveedores} placeholder={proveedor?.name} value={proveedor} onChange={(e) => { setProveedor(e.value) }} titulo={"Proveedor"}></InputLista>
                            <InputLista options={operadores} placeholder={operador?.name} value={operador} onChange={(e) => { setOperador(e.value) }} titulo={"Operador"}></InputLista>
                            <TextArea onChange={(e) => { setMotivo(e.target.value) }} value={motivo} titulo="Motivo"></TextArea>
                        </div>

                        {/* Información sobre transferencias - NUEVO */}
                        <div className="info-transferencia-container">
                            <div className="info-header">
                                <i className="pi pi-info-circle"></i>
                                <span>Información importante sobre transferencias</span>
                            </div>
                            <div className="info-content">
                                <div className="tiempo-info">
                                    <i className="pi pi-clock"></i>
                                    <span>Para evitar generar incidencias, las transferencias deben realizarse <strong>40 minutos antes</strong> de la hora de inicio del servicio.</span>
                                </div>
                            </div>
                        </div>

                        {registrarIncidencia == 0 && (
                            <div className="buttonContainer">
                                <Button className={"buttonTransferir"} onClick={() => { send() }}>
                                    <i className="pi pi-arrow-right"></i>
                                    Transferir
                                </Button>
                            </div>
                        )}
                    </div>
                </b>

                {/* Sección de bitácoras con simbología mejorada */}
                {data && motivo && registrarIncidencia == 1 && estructura && (proveedor?.code !== 1 || operador) && (
                    <>
                        {/* Simbología de colores - NUEVO */}
                        <div className="simbologia-section">
                            {/* <div className="simbologia-header">
                                <i className="pi pi-palette"></i>
                                <span>Simbología de bitácoras</span>
                            </div> */}
                            <div className="simbologia-items">
                                <div className="simbologia-item">
                                    <div className="color-sample verde"></div>
                                    <span><strong>Verde:</strong> No genera incidencia (transferencia a tiempo)</span>
                                </div>
                                <div className="simbologia-item">
                                    <div className="color-sample rojo"></div>
                                    <span><strong>Rojo:</strong> Genera incidencia (menos de 40 min antes del inicio)</span>
                                </div>
                            </div>
                        </div>

                        <div style={{ marginTop: '20px' }} className="TablaBitacoras">
                            <div className="titulo">
                                <span>RUTA: {ruta?.name} | BITÁCORA(S):</span>
                                {data?.map((item, index) => (
                                    <div key={index} className="bitacoras-conatiner">
                                        <Tooltip title={`Fecha: ${item.hora_arranque}`}>
                                            <div className={`bitacoras ${item.mostrar_incidencia == 1 ? "incidencia_repentina" : ""}`}>
                                                {item.bitacora}
                                            </div>
                                        </Tooltip>
                                    </div>
                                ))}
                            </div>
                            <div className="margen">
                                <div className="conainerFecha">
                                    {/* <InputCalendario className={"inputCalendarioModal"} titulo={"Fecha"} value={fecha} onChange={(e) => { setFecha(e.target.value) }}></InputCalendario> */}
                                    {/* <label htmlFor=""  >&nbsp; <input checked={afectoServicioCheck} onChange={(e) => { setAfectoServicioCheck(e.target.checked) }} type="checkbox" /> Afectó el servicio? &nbsp;</label>
                                    <label htmlFor="">&nbsp; <input checked={responsabilidadSumaCheck} onChange={(e) => { setResponsabilidadSumaCheck(e.target.checked) }} type="checkbox" /> Es responsabilidad de Suma? &nbsp; </label> */}
                                </div>
                                <div className="containerCEDN">
                                    <div className="cont">
                                        <InputLista placeholder={causa?.name} options={causas} value={causa} onChange={(e) => { setCausa(e.value); setEfecto(null) }} titulo={"Causa"}></InputLista>
                                        <TextArea onChange={(e) => { setDetalle(e.target.value) }} value={detalle ? detalle : ""} titulo={"Detalle"} className={"textAreaClass"}></TextArea>
                                    </div>
                                    <div className="cont">
                                        <InputLista options={efectos} value={efecto} onChange={(e) => { setEfecto(e.value) }} titulo={"Efecto"}></InputLista>
                                    </div>
                                </div>
                            <div className="buttonContainer" style={{ marginTop: '0px' }}>
                                <Button className={"buttonTransferir"} onClick={() => { send() }}>
                                    <i className="pi pi-send"></i>
                                    Transferir
                                </Button>
                            </div>
                            </div>
                        </div>
                    </>
                )}

                {/* Mensaje de éxito mejorado */}
                {transeferir?.bitacoras_modificar && (
                    <div className="mensaje-exito-mejorado">
                        <div className="exito-header">
                            <i className="pi pi-check-circle"></i>
                            <span>Se transfirió correctamente</span>
                        </div>
                        <div className="exito-content">
                            <div className="bitacoras-label">Bitácora(s) transferidas:</div>
                            <div className="bitacoras-lista">
                                {transeferir.bitacoras_modificar.map((item, key) => (
                                    <div key={key} className="bitacora-transferida">
                                        <i className="pi pi-check"></i>
                                        <span>{item.ID_BITACORA}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* Mensaje de error original sin cambios */}
                {transeferir?.bitacoras_modificar && (
                    <div className="mensajeError" style={{ display: 'none' }}>
                        <div className="mensajeErrorTitulo">Se transfirio correctamente</div>
                        <div className="mensajeErrorDescripcion">Bitacora(s):</div>
                        {transeferir?.bitacoras_modificar.map((item, key) => (
                            <div key={key} className="lista">{item.ID_BITACORA}</div>
                        ))}
                    </div>
                )}
            </GlovalCard>
        </div >
    )
}
export default TransferirServicios